import $ from "jquery";

$(function () {
  // Lämna kvar kommentaren för att göra det lättare för oss i framtiden att förstå vart SVG definitionerna läses in i CMS:et /Lucas
  console.log("Importing svg definitions for Streamline Icons...");

  let id = "svg-container";
  $("body").append('<div id="' + id + '"></div>');

  let host = location.protocol + "//" + location.host;

  $("#" + id).load(host + "/icons/IconSvgDefinitionsV3.html");
});
